import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEscolaMidias, type MidiaEscola } from '../../api/hooks/useEscolaMidias';
import { useAuthStore } from '../../store/authStore';
import { usePermissions } from '../../hooks/usePermissions';
import { MediaCenterCore } from '../../components/medias/MediaCenterCore';
import {
  ESCOLA_MEDIA_CATEGORIAS,
  type MediaConfig,
  type MediaItem,
  type MediaUploadPayload,
} from '../../components/medias/MediaConfig';

export function MidiasEscolaPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { escolaId } = useAuthStore();
  const { canManage } = usePermissions();
  const { midias, isLoading, create, remove } = useEscolaMidias();

  const config: MediaConfig = useMemo(
    () => ({
      scope: 'ESCOLA',
      scopeId: escolaId || '',
      labels: {
        heroTitle: 'Banco de Mídias Escolar',
        heroSubtitle:
          'Gerencie folders, avisos e imagens institucionais da escola. Dispare comunicados visuais para as famílias.',
        searchPlaceholder: 'Buscar folders da escola...',
        emptyTitle: 'Nenhuma mídia escolar cadastrada ainda',
        emptySubtitle:
          'Faça upload de folders para reuniões, feiras, avisos e cardápios para disparar aos pais.',
      },
      categories: ESCOLA_MEDIA_CATEGORIAS,
      features: {
        allowCompress: true,
        maxFileSizeMb: 10,
        showHowItWorksBanner: true,
        showSetupHero: false,
        canManage: canManage('comunicados'),
      },
      onSendToComunicado: (m: MediaItem) => {
        const draft = {
          midiaId: m.id,
          titulo: m.titulo,
          descricao: m.descricao,
          arquivoUrl: m.arquivoUrl,
          categoria: m.categoria,
        };
        const target = location.pathname.replace(/\/midias\/?$/, '/comunicados');
        navigate(target, { state: { fromMidia: draft } });
      },
    }),
    [escolaId, location.pathname, navigate],
  );

  return (
    <MediaCenterCore
      config={config}
      midias={midias as unknown as MediaItem[]}
      isLoading={isLoading}
      onCreate={(payload: MediaUploadPayload) =>
        create.mutateAsync(payload as unknown as Record<string, unknown>)
      }
      onRemove={(id: string) => remove.mutateAsync(id)}
    />
  );
}
